import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/invoice/";

export function cancelInvoice(invoiceID = 0) {
  return http.delete(apiEndpoint + "invoice/" + invoiceID);
}

export function saveInvoice(invoice) {
  return http.post(apiEndpoint, invoice);
}

export function getInvoice() {
  return http.get(apiEndpoint);
}

export function getInvoiceDetail(invoiceID = 0, passAuth = "false") {
  return http.get(apiEndpoint + "invoice-detail/" + invoiceID + "/" + passAuth);
}

export function getRecInvoiceDetail(invoiceID) {
  return http.get(apiEndpoint + "rec-invoice-detail/" + invoiceID);
}

export function getInvoicesByDocRef(docRef = "", docID = 0) {
  return http.get(apiEndpoint + "doc-ref-invoices/" + docRef + "/" + docID);
}

export function getInvoicesDocRef() {
  return http.get(apiEndpoint + "invoice-doc-ref");
}
